/* eslint-disable import/prefer-default-export */
export const ACTION_TYPE = {
  SWITCH_LANGUAGE: "SWITCH_LANGUAGE",
  STORE_TRANSLATION: "STORE_TRANSLATION",
  STORE_TRANSLATION_FAIL: "STORE_TRANSLATION_FAIL",

  FORM_OPTION_SUCCESS: "FORM_OPTION_SUCCESS",
  FORM_OPTION_FAIL: "FORM_OPTION_FAIL",

  FORM_SUBMIT_CLICK: "FORM_SUBMIT_CLICK",
  FORM_SUBMIT_INIT: "FORM_SUBMIT_INIT",

  APPLICANT: {
    REF_CODE: "REF_CODE",
    PRODUCT_CODE: "PRODUCT_CODE",
    CREATE_APPLICANT: "CREATE_APPLICANT",
    UPDATE_APPLICANT: "UPDATE_APPLICANT",
    GET_APPLICANT: "GET_APPLICANT",
    UPDATE_APPLICANT_SUCCESS: "UPDATE_APPLICANT_SUCCESS",
    APPLICANT_FAIL: "APPLICANT_FAIL",
    APPLICANT_PDF: "APPLICANT_PDF",
    APPLICANT_PDF_GENERATED: "APPLICANT_PDF_GENERATED",
    APPLICANT_PDF_REFRESH: "APPLICANT_PDF_REFRESH",
    APPLICANT_FATCA_PDF: "APPLICANT_FATCA_PDF",
    APPLICANT_TC_PDF: "APPLICANT_TC_PDF",
    APPLICANT_ALLOCATION_PDF: "APPLICANT_ALLOCATION_PDF",
    APPLICANT_MFT_PDF: "APPLICANT_MFT_PDF",
    APPLICANT_CRS_PDF: "APPLICANT_CRS_PDF",
    APPLICANT_NDPF_PDF: "APPLICANT_NDPF_PDF",
    APPLICANT_PDF_FAIL: "APPLICANT_PDF_FAIL",
    APPLICANT_ASSET_ALLOCATION_PDF: "APPLICANT_ASSET_ALLOCATION_PDF",
    APPLICANT_DPF_PDF: "APPLICANT_DPF_PDF",
    APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_PDF:
      "APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_PDF",
    APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_SHARIA_PDF:
      "APPLICANT_INVESTMENT_STRATEGY_ABSOLUTE_SHARIA_PDF",
    APPLICANT_IREP_PDF: "APPLICANT_IREP_PDF",
    APPLICANT_CPF_PDF: "APPLICANT_CPF_PDF",
    APPLICANT_CUSTOM_SUB_AGREEMENT: "APPLICANT_CUSTOM_SUB_AGREEMENT",
    APPLICANT_CUSTOM_SUB_PORTFOLIO: "APPLICANT_CUSTOM_SUB_PORTFOLIO", // this is to replace APPLICANT_CUSTOM_SUB_AGREEMENT
    APPLICANT_DIVIDEND_YIELD: "APPLICANT_DIVIDEND_YIELD",
    SEND_EMAIL_SUCCESS: "SEND_EMAIL_SUCCESS",
    SEND_EMAIL_FAIL: "SEND_EMAIL_FAIL",
    IS_ALL_COMPLETED: "IS_ALL_COMPLETED",
    OTHER_APPLICATION_DETAILS: "OTHER_APPLICATION_DETAILS",
    SAVE_LATEST_REF_CODE: "SAVE_LATEST_REF_CODE",
    REWORK_STATUS: "REWORK_STATUS",
    SAVE_PROOF_OF_TRANSFER: "SAVE_PROOF_OF_TRANSFER",
    SAVE_PACI_FRONT_STATUS: "SAVE_PACI_FRONT_STATUS",
  },

  AUTH: {
    UPDATE_PHONE_NUMBER: "UPDATE_PHONE_NUMBER",
    UPDATE_EMAIL_ADDRESS: "UPDATE_EMAIL_ADDRESS",
    REQUEST_OTP_SUCCESS: "REQUEST_OTP_SUCCESS",
    UPDATE_IS_USER_EXISTING: "UPDATE_IS_USER_EXISTING",
    VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
    VALIDATE_TOKEN_SUCCESS: "VALIDATE_TOKEN_SUCCESS",
    AUTH_FAIL: "AUTH_FAIL",
    LOGOUT: "LOGOUT",
    SAVE_DS_USER_DETAIL: "SAVE_DS_USER_DETAIL",
    RESET_DS_USER_DETAIL: "RESET_DS_USER_DETAIL",
  },

  STEPS: {
    UPDATA_CURRENT_STEP: "UPDATA_CURRENT_STEP",
    UPDATE_STEP_SUCCESS: "UPDATE_STEP_SUCCESS",
    UPDATE_STEP_FAIL: "UPDATE_STEP_FAIL",
  },

  ID_PASSPORT: {
    UPDATE_ID_PASSPORT_DATA: "UPDATE_ID_PASSPORT_DATA",
    FETCH_ID_PASSPORT: "FETCH_ID_PASSPORT",
  },

  PERSONAL_INFORMATION: {
    FETCH_PERSONAL_INFORMATION: "FETCH_PERSONAL_INFORMATION",

    UPDATE_CLIENT_DATA: "UPDATE_CLIENT_DATA",
    CD_QUALIFIED_INVESTOR_OPTIONS: "CD_QUALIFIED_INVESTOR_OPTIONS",
    CD_INVESTMENT_STRATEGIES: "CD_INVESTMENT_STRATEGIES",

    PEP: "PEP",
    IS_PEP: "IS_PEP",
    PEP_BENEFICIARIES: "PEP_BENEFICIARIES",

    UPDATE_BANK_DETAILS: "UPDATE_BANK_DETAILS",
    UPDATE_CARD_INFO: 'UPDATE_CARD_INFO',
    UPDATE_SOURCE_OF_WEALTH: "UPDATE_SOURCE_OF_WEALTH",

    UPDATE_ASI: "UPDATE_ASI",
    SAVE_ASI_POA: "SAVE_ASI_POA",

    UPDATE_CLIENT_PROFILE: "UPDATE_CLIENT_PROFILE",
    UPDATE_CLIENT_PROFILE_ASSET_CLASSES: "UPDATE_CLIENT_PROFILE_ASSET_CLASSES",
    UPDATE_CLIENT_PROFILE_MARKETS: "UPDATE_CLIENT_PROFILE_MARKETS",
    AUTO_UPDATE_CLIENT_PROFILE_INVESTMENT_EXP: 'AUTO_UPDATE_CLIENT_PROFILE_INVESTMENT_EXP',
    HAVE_INVESTMENT_EXP: 'HAVE_INVESTMENT_EXP',

    UPDATE_INSIDER_STATUS_LIST: "UPDATE_INSIDER_STATUS_LIST",
  },

  FATCA_CRS: {
    FETCH_FATCA_CRS: "FETCH_FATCA_CRS",
    UPDATE_FATCA: "UPDATE_FATCA",
    AUTO_UPDATE_FATCA: "AUTO_UPDATE_FATCA",
    CLEAR_FATCA_DATA_EXCEPT_Q1: "CLEAR_FATCA_DATA_EXCEPT_Q1",
    UPDATE_CRS: "UPDATE_CRS",
    UPDATE_TAX_LIST: "UPDATE_TAX_LIST",
  },

  AGREEMENTS: {
    UPDATE_AOF_KYC: "UPDATE_AOF_KYC",
    UPDATE_PROFILE: "UPDATE_PROFILE",
    FETCH_AGREEMENTS: "FETCH_AGREEMENTS",
    ACKNOWLEDGEMENT_UNDERTAKING: "ACKNOWLEDGEMENT_UNDERTAKING",
    PROPOPOSED_PLAN: "PROPOSED_PLAN",
    SIGNATURE: "SIGNATURE",
    TIMESTAMP_AOFKYC_PROFILE: "TIMESTAMP_AOFKYC_PROFILE",
    TIMESTAMP_NDPF_PROPOSED_PLAN: "TIMESTAMP_NDPF_PROPOSED_PLAN",
    IS_AGREEMENT_READY_FOR_QUALIFIED: "IS_AGREEMENT_READY_FOR_QUALIFIED",
    IS_CUSTOM_AA_UPLOADED: "IS_CUSTOM_AA_UPLOADED",
  },

  CATALOGUE: {
    FETCH_SCREENER: "FETCH_SCREENER",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
  },
};
